import React, { ReactNode } from 'react';
import { useDispatch } from 'react-redux';

import { cx } from '@travel/utils';
import { FlatButton } from '@travel/ui';
import { Translate } from '@travel/translation';

import { UserScopeType } from 'utils/userScopeHelper';
import { getIsSwitchUser, getIsInternalSwitchUser, PLATFORM, getUserPlatform } from 'utils';

import { logout, switchUser } from 'store/login/actions';

import styles from './navigationMenu.module.scss';
import { getBgColor } from '../getBackgroundColor';

type Props = {
  name?: string;
  id: string;
  basePath: string;
  userScope: UserScopeType;
};

type BackToExtranetProps = {
  id: string;
  name: ReactNode;
  userScope: UserScopeType;
};

function BackToExtranet(props: BackToExtranetProps) {
  const dispatch = useDispatch();
  const { id, userScope } = props;
  const isInternalSwitchUser = getIsInternalSwitchUser(userScope);
  const returnInternal = <Translate id="Extranet_Header.Back_To_Internal_Tool" />;
  const returnToGroupExtranet = <Translate id="Extranet_Header.Back_To_Group_Extranet" />;

  const backToExtranet = () => {
    if (isInternalSwitchUser) {
      dispatch(logout({ redirectToSSO: true }));
    } else {
      dispatch(switchUser(id, true));
    }
  };

  return (
    <>
      <FlatButton
        classType={'secondary'}
        onClick={backToExtranet}
        className={styles.returnBtn}
        data-testid="backToExtranet"
      >
        {isInternalSwitchUser ? returnInternal : returnToGroupExtranet}
      </FlatButton>
    </>
  );
}

function MenuHeader(props: Props) {
  const { name, id, userScope } = props;

  const platform = getUserPlatform(userScope);
  const isSwitchUser = getIsSwitchUser(userScope);
  const bgColor = getBgColor(platform);

  return (
    <div data-locator-id="menuHeader-Wrapper">
      <div
        className={cx(
          styles.rootNav,
          styles.suspendedContent,
          bgColor,
          platform === PLATFORM.INTERNAL && styles.paddingTop,
        )}
      >
        <div className={styles.headSection}>
          <div className={styles.heading}>
            <p>{name}</p>
          </div>
          {id && (
            <p className={styles.provider}>
              <Translate id="Extranet_Header.ID" />: {id}
            </p>
          )}
        </div>
        {isSwitchUser && <BackToExtranet id={id} name={name} userScope={userScope} />}
      </div>
    </div>
  );
}

export default MenuHeader;
